import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

/* PICTURES & ICONS */
import ICON_SIDEBAR_CLOSE from "../../Assets/jsx/ICON_SIDEBAR_CLOSE";
import ICON_SIDEBAR_OPEN from "../../Assets/jsx/ICON_SIDEBAR_OPEN";
import icon_mapid_apps_png from "../../Assets/png_jpg/icon_mapid_apps.png";
import icon_mapid_apps from "../../Assets/svg/icon_mapid_apps.svg";
import icon_gps from "../../Assets/svg/icon_gps.svg";
import icon_compass from "../../Assets/svg/icon_compass.svg";
import icon_zoom_in from "../../Assets/svg/icon_zoom_in.svg";
import icon_zoom_out from "../../Assets/svg/icon_zoom_out.svg";
import setting from "../../Assets/svg/setting.svg";

import { post_activities } from "../../App/actions/activities";

const MAP_SIDE_CONTROLS = ({
  is_mobile,
  sidebarClass,
  get_dynamic_bottom,
  sidebar_right_status,
  toggle_sidebar_right,

  // Mapid Apps Props
  is_community_loading,
  on_click_mapid_apps,
  is_show_activity,
  toggle_show_activity,
  is_show_image,
  toggle_show_image,
  is_show_property,
  toggle_show_property,

  // GPS & Compass Props
  on_geolocate,
  gps_class,
  on_reset_compass,
  on_cinematic_view, // <-- PROP FOR CINEMATIC VIEW
  compass_ref,

  // Zoom Props
  handleZoomInStart,
  handleZoomOutStart,
  clearZoomTimers,
  currentZoom,

  // Settings & Feedback
  on_open_setting,
  is_show_feedback_button,
  showFeedback,
  setShowFeedback,
}) => {
  const dispatch = useDispatch(); // 3. Initialize dispatch

  // Local state for the Mapid Apps menu
  const [isMapidAppsOpen, setIsMapidAppsOpen] = useState(false);
  const mapidAppsRef = useRef(null);

  // Local state for the Compass flyout menu
  const [isCompassMenuOpen, setIsCompassMenuOpen] = useState(false);
  const compassMenuRef = useRef(null);

  // Handle clicking or touching outside to close the Mapid Apps menu
  useEffect(() => {
    const handleOutsideInteraction = (event) => {
      if (
        mapidAppsRef.current &&
        !mapidAppsRef.current.contains(event.target)
      ) {
        setIsMapidAppsOpen(false);
      }
    };

    if (isMapidAppsOpen) {
      document.addEventListener("mousedown", handleOutsideInteraction);
      document.addEventListener("touchstart", handleOutsideInteraction); // Added for touch devices
    } else {
      document.removeEventListener("mousedown", handleOutsideInteraction);
      document.removeEventListener("touchstart", handleOutsideInteraction);
    }

    return () => {
      // Cleanup both listeners
      document.removeEventListener("mousedown", handleOutsideInteraction);
      document.removeEventListener("touchstart", handleOutsideInteraction);
    };
  }, [isMapidAppsOpen]);

  // Handle clicking or touching outside to close the Compass menu
  useEffect(() => {
    const handleOutsideInteraction = (event) => {
      if (
        compassMenuRef.current &&
        !compassMenuRef.current.contains(event.target)
      ) {
        setIsCompassMenuOpen(false);
      }
    };

    if (isCompassMenuOpen) {
      document.addEventListener("mousedown", handleOutsideInteraction);
      document.addEventListener("touchstart", handleOutsideInteraction); // Added for touch devices
    } else {
      document.removeEventListener("mousedown", handleOutsideInteraction);
      document.removeEventListener("touchstart", handleOutsideInteraction);
    }

    return () => {
      // Cleanup both listeners
      document.removeEventListener("mousedown", handleOutsideInteraction);
      document.removeEventListener("touchstart", handleOutsideInteraction);
    };
  }, [isCompassMenuOpen]);

  const handleMapidAppsClick = () => {
    setIsMapidAppsOpen(true);
    on_click_mapid_apps();
    dispatch(
      post_activities({
        action: "trigger_mapid_apps",
      }),
    );
  };

  return (
    <>
      {!is_mobile && (
        <button
          id="sidebar_right_ui"
          className={`map_button_control right_sidebar_toggle ${sidebarClass}`}
          style={get_dynamic_bottom(408)}
          onClick={toggle_sidebar_right}
        >
          {sidebar_right_status ? (
            <ICON_SIDEBAR_CLOSE color="#000" style={{ width: "15px" }} />
          ) : (
            <ICON_SIDEBAR_OPEN color="#000" style={{ width: "15px" }} />
          )}
        </button>
      )}

      <div
        id="mapid_apps_ui"
        ref={mapidAppsRef}
        className={`mapid_apps_wrapper ${sidebarClass}`}
        style={get_dynamic_bottom(360)}
      >
        <div className={`mapid_apps_pill ${isMapidAppsOpen ? "active" : ""}`}>
          <div className="mapid_apps_header">
            <button
              className="mapid_apps_close"
              onClick={() => setIsMapidAppsOpen(false)}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#000",
            }}
            className="margin_bottom_extra"
          >
            <p style={{ margin: 0, fontSize: "21px", fontWeight: 700 }}>From</p>
            <img src={icon_mapid_apps_png} alt="Apps" width={77} />
          </div>

          {/* ACTIVITIES */}
          <div className="mapid_apps_item" onClick={toggle_show_activity}>
            <button
              className={
                is_show_activity ? "checklist_active" : "checklist_not"
              }
            />
            <div
              style={{
                width: "32px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    backgroundColor: "#FFFFFF",
                    border: "2px solid white",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.3)",
                    boxSizing: "content-box",
                  }}
                >
                  <div style={{ fontSize: "16px" }}>😊</div>
                </div>
                <div
                  style={{
                    width: 0,
                    height: 0,
                    borderLeft: "5px solid transparent",
                    borderRight: "5px solid transparent",
                    borderTop: "6px solid white",
                    marginTop: "-1px",
                    filter: "drop-shadow(0px 2px 1px rgba(0,0,0,0.2))",
                  }}
                ></div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <p style={{ margin: 0, lineHeight: "1.2" }}>Activities</p>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  marginTop: "4px",
                  alignItems: "center",
                }}
              >
                <span
                  style={{ fontSize: "9px", color: "#888", fontWeight: "600" }}
                >
                  HEATMAP:
                </span>
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#22c55e",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                  }}
                />
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#eab308",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                  }}
                />
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#ef4444",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                  }}
                />
              </div>
            </div>
          </div>

          {/* PROPERTY GO */}
          <div className="mapid_apps_item" onClick={toggle_show_property}>
            <button
              className={
                is_show_property ? "checklist_active" : "checklist_not"
              }
            />
            <div
              style={{
                width: "32px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    backgroundColor: "#E02E2E",
                    border: "2px solid white",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.3)",
                    boxSizing: "content-box",
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                </div>
                <div
                  style={{
                    width: 0,
                    height: 0,
                    borderLeft: "5px solid transparent",
                    borderRight: "5px solid transparent",
                    borderTop: "6px solid white",
                    marginTop: "-1px",
                    filter: "drop-shadow(0px 2px 1px rgba(0,0,0,0.2))",
                  }}
                ></div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <p style={{ margin: 0, lineHeight: "1.2" }}>Property Go</p>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  marginTop: "4px",
                  alignItems: "center",
                }}
              >
                <span
                  style={{ fontSize: "9px", color: "#888", fontWeight: "600" }}
                >
                  HEATMAP:
                </span>
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#3b82f6",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                  }}
                />
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#a855f7",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                  }}
                />
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#ef4444",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                  }}
                />
              </div>
            </div>
          </div>

          {/* SHOW PHOTOS / TEXTS */}
          <div className="mapid_apps_item margin_top">
            <div
              className="two_container_equal"
              style={{
                display: "flex",
                width: "100%",
                gap: "8px",
                alignItems: "stretch",
              }}
            >
              <button
                className={`container text_medium ${is_show_image ? "background_black" : "background_grey_light"}`}
                onClick={() => {
                  if (!is_show_image) toggle_show_image();
                }}
              >
                Show photos
              </button>
              <button
                className={`container text_medium ${!is_show_image ? "background_black" : "background_grey_light"}`}
                onClick={() => {
                  if (is_show_image) toggle_show_image();
                }}
              >
                Show texts
              </button>
            </div>
          </div>
        </div>

        <button
          className={`map_button_control mapid_apps_btn_inner ${is_community_loading ? "halo_loading" : ""}`}
          onClick={handleMapidAppsClick}
          data-mapid="clickMapidApps"
        >
          <img src={icon_mapid_apps} height={25} alt="Apps" />
        </button>
      </div>

      <button
        id="gps_ui"
        className={`map_button_control gps_map ${sidebarClass}`}
        style={get_dynamic_bottom(312)}
        onClick={() => on_geolocate(3)}
        data-mapid="clickGPS"
      >
        <img
          id="icon_gps"
          alt="Geolocate"
          src={icon_gps}
          width={15}
          className={gps_class}
        />
      </button>

      {/* COMPASS FLYOUT WRAPPER */}
      <div
        ref={compassMenuRef}
        className={`compass_wrapper ${sidebarClass}`}
        style={get_dynamic_bottom(264)}
      >
        {/* The Flyout Menu */}
        <div
          className={`compass_flyout_menu ${isCompassMenuOpen ? "open" : ""}`}
        >
          <button
            className="compass_flyout_item"
            onClick={(e) => {
              setIsCompassMenuOpen(false);
              if (on_reset_compass) on_reset_compass(e);
            }}
          >
            Reset
          </button>

          <div className="compass_flyout_divider" />

          <button
            className="compass_flyout_item"
            onClick={(e) => {
              setIsCompassMenuOpen(false);
              if (on_cinematic_view) on_cinematic_view(e);
            }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
            Cinematic
          </button>
        </div>

        {/* The Original Compass Button */}
        <button
          id="compass_ui"
          className="map_button_control"
          onClick={() => setIsCompassMenuOpen(!isCompassMenuOpen)}
          data-mapid="clickCompas"
        >
          <img
            id="map_compass"
            ref={compass_ref}
            alt="Compass Options"
            src={icon_compass}
            height={17}
          />
        </button>
      </div>

      <div
        id="zoom_ui"
        className={`zoom_pill_container ${sidebarClass}`}
        style={get_dynamic_bottom(146)}
      >
        <button
          className="zoom_pill_button"
          onMouseDown={handleZoomInStart}
          onMouseUp={clearZoomTimers}
          onMouseLeave={clearZoomTimers}
          onTouchStart={handleZoomInStart}
          onTouchEnd={clearZoomTimers}
          data-mapid="clickZoomIn"
        >
          <img alt="Zoom In" src={icon_zoom_in} width={11} />
        </button>
        <div className="zoom_pill_indicator">{currentZoom.toFixed(1)}</div>
        <button
          className="zoom_pill_button"
          onMouseDown={handleZoomOutStart}
          onMouseUp={clearZoomTimers}
          onMouseLeave={clearZoomTimers}
          onTouchStart={handleZoomOutStart}
          onTouchEnd={clearZoomTimers}
          data-mapid="clickZoomOut"
        >
          <img alt="Zoom Out" src={icon_zoom_out} width={11} />
        </button>
      </div>

      <button
        id="setting_ui"
        className={`map_button_control setting_map ${sidebarClass}`}
        style={get_dynamic_bottom(98)}
        onClick={on_open_setting}
        data-mapid="clickTool"
      >
        <img src={setting} height={15} alt="sat" />
      </button>

      {is_show_feedback_button !== false && (
        <button
          id="feedback_ui"
          className="feedback_button"
          onClick={() => setShowFeedback(!showFeedback)}
          aria-expanded={showFeedback}
          aria-label="Toggle Masukan"
        >
          {showFeedback ? (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          ) : (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          )}
        </button>
      )}
    </>
  );
};

export default MAP_SIDE_CONTROLS;
